// extracted by mini-css-extract-plugin
export default {"relogioNumero":"Relogio_relogioNumero__UO-PB","relogioDivisao":"Relogio_relogioDivisao__9vQKK"};